import Vue from 'vue';
import { track } from '../tracking/trackingLayer';

export default {
  props: {
    artikel: {
      type: Object,
      required: true,
    },
    artikelNr: {
      type: String,
      required: true,
    },
    isInitialArticle: {
      type: Boolean,
      required: true,
    },
    dimension: {
      type: String,
      required: true,
    },
  },

  template: '#warenkorbbutton-template',

  created() {
    this.$parent.$on('bewerten:vue:artikel:emit', (currentArtikelNr) => {
      this.artikelNr = currentArtikelNr;
      this.isInitialArticle = false;
      this.emitCartContent();
    });
    this.$parent.$on('bewerten:vue:send:tracking:warenkorb', (eventValues) => {
      this.sendTrackingInfo(eventValues);
    });
  },

  methods: {
    a2cClick() {
      if (this.artikel.outofstock) {
        this.handleOutOfStockVariant();
      } else {
        this.addToCart();
      }
    },

    // this method is used for mocking in unit tests
    getVerkaufId() {
      return this.artikel.verkaufId;
    },
    // this method is used for mocking in unit tests
    getVertriebsinfoId() {
      return this.artikel.vertriebsinfoId;
    },

    getPayload() {
      const payload = {
        detail: {
          artikel: this.getVerkaufId(),
          menge: 1,
        },
      };
      const vertriebsinfoId = this.getVertriebsinfoId();
      if (vertriebsinfoId) {
        payload.detail.vertriebsinfoId = vertriebsinfoId;
      }
      return payload;
    },

    emitCartContent() {
      // see: https://brix.dev.breuni.de/kaufen/sandbox/ssi.html
      const payload = this.getPayload();
      const customKaufCartAddEvent = new CustomEvent('kaufen:cart:add', payload);
      document.dispatchEvent(customKaufCartAddEvent);
      console.info('Artikel wurde an den Warenkorb übergeben:', payload);
      this.$el.setAttribute('data-test-bewerten-warenkorbbutton-payload-emitted', JSON.stringify(payload));
      window.performance.mark('bewe.pds.warenkorbbutton.payload-emitted');
    },

    handleOutOfStockVariant() {
      if (this.isInitialArticle) {
        this.$parent.$emit('bewerten:vue:dimension:select', { dimension: this.dimension });
      } else {
        this.$bus.$emit('bewerten:out-of-stock-layer:show', this.getVertriebsinfoId());
      }
    },

    addToCart() {
      if (this.isInitialArticle) {
        this.$parent.$emit(
          'bewerten:vue:dimension:select',
          {
            dimension: this.dimension,
            add2CartAfterSizeSelection: true,
          },
        );
        this.$parent.$on('bewerten:vue:layer:hide', () => {
          Vue.nextTick(() => {
            this.emitCartContent();
          });
        });
        this.sendTrackingInfo(['click', 'cart_sizelayer']);
      } else if (this.artikelNr) {
        this.emitCartContent();
      }
    },

    sendTrackingInfo(eventValues) {
      track({
        event_level1: 'ents',
        event_level2: null,
        event_level3: null,
        event_level4: null,
        event_level5: null,
        event: 'event.generic',
        event_values: eventValues,
      });
    },
  },
};
